/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Integrations_Error_LoadingInputs */



/**
* | output |
* | --- |
* | "Error loading integration settings. Please try again." |
*
* @param {Options_Integrations_Error_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_integrations_error_loading = /** @type {((inputs?: Options_Integrations_Error_LoadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Integrations_Error_LoadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur lors du chargement des paramètres d'intégration. Veuillez réessayer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Laden der Integrationseinstellungen. Bitte versuchen Sie es erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore durante il caricamento delle impostazioni di integrazione. Riprova.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка при загрузке настроек интеграции. Пожалуйста, попробуйте еще раз.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al cargar la configuración de integración. Inténtalo de nuevo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载集成设置时出错。请重试。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("統合設定の読み込み中にエラーが発生しました。もう一度お試しください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एकीकरण सेटिंग्स लोड करने में त्रुटि। कृपया पुनः प्रयास करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro ao carregar as configurações de integração. Tente novamente.")
	return /** @type {LocalizedString} */ ("Error loading integration settings. Please try again.")
});